<template>
	<div :id="id" class="position-relative filter-container">
		<v-date-picker
				v-if="isDataPicker && !type && (modelFilter === 'date' || modelFilter === 'filter_created_date')"
				width="300"
				color="green"
				class="picker-table"
				:disabled="isDisabled"
				v-model="dates"
				@input="onChange"
				range
		></v-date-picker>
		<v-combobox
				v-if="!isDataPicker && !type && (modelFilter !== 'date' || modelFilter !== 'filter_created_date')"
				v-model="select"
				:items="items"
				:label="'Select ' + label"
				item-text="value"
				item-value="id"
				class="green-icon"
				color="green"
				:attach="'#'+id"
				:menu-props="{contentClass: 'filter-dd', maxWidth: 300, minWidth: 300, nudgeWidth: 300}"
				@input="changeFilter($event, 'select')"
				multiple
				clearable
				small-chips
				deletable-chips
				chips
		></v-combobox>
		<v-text-field
				v-if="!isDataPicker && type && modelFilter === 'filter_load_count'"
				v-model="valueText"
				@input="onTextField"
				type="number"
				clearable
				placeholder="Enter loads n"
				class="green-icon"
				:content-class="'filter-popover__child'"
				dense
		></v-text-field>
	</div>
</template>
<script>
import { mapActions } from "vuex";
import debounce from 'lodash.debounce';

export default {
	props: {
		type: Boolean,
		isDataPicker: Boolean,
		isDisabled: Boolean,
		dataFilter: {
			type: Array,
			default: () => []
		},
		modelFilter: {
			type: String,
			default: ''
		},
		filterUpdate: {
			type: Boolean
		},
		labelFilter: {
			type: String
		},
		typeFilter: {
			type: String,
			default: 'list'
		},
		uniqId: Object,
		refreshDate: String
	},
	data() {
		return {
			select: [],
			valueText: null,
			dates: [ new Date().toISOString().substr(0, 10) ]
		};
	},
	computed: {
		items() {
			return this.dataFilter.filter((value) => value != null && value);
		},
		id() {
			return "dd" + Math.round((Math.random() * (1000 - 20)) + 10);
		},
		update() {
			return this.filterUpdate;
		},
		label() {
			switch (this.modelFilter) {
				case 'filter_customer':
					return "customer";
				case 'filter_factoring':
					return 'factoring';
				case 'filter_id':
					return 'id';
				default:
					return '';
			}
		}
	},
	methods: {
		...mapActions([ 'safetyCalendar' ]),
		changeFilter(value, key) {
			if (key === "select") {
				this.$emit("change-sort", { key: this.modelFilter, value });
			}
		},
		onChange() {
			const [ from, to = from ] = this.dates;
			const filter_date = { from, to };
			this.$emit("change-sort", { key: 'filter_created_date', value: filter_date });
		},
		onTextField: debounce(function() {
			const valueText = +this.valueText === 0 ? 0 : +this.valueText;
			this.$emit("change-sort", { key: 'filter_load_count', value: valueText });
		}, 500),
	},
	mounted() {
		this.$emit('filter-created', this.modelFilter);
	},
	watch: {
		uniqId(val, oldVal) {
			const { id, key } = val;
			const { id: oldId } = oldVal;
			if (id !== oldId && this.modelFilter === key) {
				this.select = this.items;
				this.$emit("change-sort", { key: this.modelFilter, value: this.select });
			}
		},
		filterUpdate(val) {
			if (val) {
				this.select = [];
				this.$emit('create-refresh', this.modelFilter);
			}

		},
		refreshDate(val, oldVal) {
			if (val !== oldVal) {
				this.select = [];
				this.dates = new Date().toISOString().substr(0, 10);
			}
		}
	}
};
</script>
<style lang="scss">
@import './filter-table.component';
</style>
